/**
 * Shared Client Details field presentation helpers (UI polish only).
 */

export function formatClientDetailsDate(
  value: string | null | undefined,
): string {
  if (!value) return "—";
  const raw = String(value).trim();
  // Prefer YYYY-MM-DD / ISO without timezone surprises for date-only strings.
  const dateOnly = raw.slice(0, 10);
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateOnly);
  if (match) {
    const [, y, m, d] = match;
    const parsed = new Date(Date.UTC(Number(y), Number(m) - 1, Number(d)));
    if (!Number.isNaN(parsed.getTime())) {
      return parsed.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        timeZone: "UTC",
      });
    }
  }
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return raw;
  return parsed.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export type ClientAddressParts = {
  address_street?: string | null;
  address_city?: string | null;
  address_state?: string | null;
  address_zipCode?: string | null;
  address_country?: string | null;
};

/**
 * Two-line postal display for the single Address cell:
 *   178 South Street
 *   Atlanta, GA 29848, US
 * Returns ["—"] when no address parts exist.
 */
export function formatClientAddressLines(
  account: ClientAddressParts | null | undefined,
): string[] {
  const clean = (v: string | null | undefined) => String(v ?? "").trim();
  const street = clean(account?.address_street);
  const city = clean(account?.address_city);
  const state = clean(account?.address_state);
  const zip = clean(account?.address_zipCode);
  const country = clean(account?.address_country);

  const cityState = [city, [state, zip].filter(Boolean).join(" ")]
    .filter(Boolean)
    .join(", ");
  const line2 = [cityState, country].filter(Boolean).join(", ");

  const lines = [street, line2].filter(Boolean);
  return lines.length ? lines : ["—"];
}
